(function() {
  'use strict';

  angular
    .module('contentPlayer.yammerShareCtrl', [])
    .controller('YammerShareCtrl', YammerShareCtrl);

  YammerShareCtrl.$inject = ['$scope', 'yammerService', 'MobileHelper'];

  function YammerShareCtrl($scope, yammerService, MobileHelper) {
    var groups = [{
      id: 0,
      full_name: "Post to My Colleagues",
      mugshot_url: "https://www.yammer.com/images/company_group_profile.png"
    }];
    $scope.modalData = {
      groups: groups,
      selectedGroup: groups[0],
      isMobile: MobileHelper.isMobileDevice(),
      message: $scope.yammerCModuleInfo.defaultMessage,
      network: $scope.yammerCModuleInfo.network
    };

    var styles = {
      headerStyle: {
        "background-image": "none",
        "background-color": $scope.yammerCModuleInfo.network.header_background_color + " !important" // this doesn't work. it ignores !important
      },
      headerTextStyle: {
        "color": $scope.yammerCModuleInfo.network.header_text_color
      },
      headerNetworkTextStyle: {
        "font-style": "italic",
        "color": $scope.yammerCModuleInfo.network.header_text_color
      }
    };

    $scope.style = function(item) {
      if (item === "headerText") {
        return styles.headerTextStyle;
      } else if (item === "headerNetworkText") {
        return styles.headerNetworkTextStyle;
      }
    };

    $scope.sendYam = function() {
      yammerService.sendYammerMessage({
        message: $scope.modalData.message,
        groupId: $scope.modalData.selectedGroup.id,
        cModuleId: $scope.cModule.id
      }, function(message) {
        // empty
      }, function(err) {
        return true;
      });
      $scope.$close();
    };

    $scope.selectGroup = function(group) {
      $scope.modalData.selectedGroup = group;
    };

    function setup() {
      $scope.modalData.groups = groups.concat($scope.yammerCModuleInfo.groups);
    }

    setup();

  }
})();
